import React from 'react';
import SEO from '../../../common/SEO';
import Layout from '../../../common/Layout';
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne';
import RegisterProgramForm from '../../../components/form/register-program-form/RegisterProgramForm';
// import { Link } from 'react-router-dom';

const EventData = [
	{
		"id": 1,
		"title": "AI for Green Hydrogen Microgrid Optimization",
		"image": "hydrogen_microgrid.webp",
		// "website": "https://www.chmltech-consulting.com/",
		// "industry": "CleanTech",
		// "rating": "4.8 Google Rating",
		// "duration": "12 Weeks",
		"category": "CleanTech",
		"location": "https://www.chmltech-consulting.com/",
		// "going": "140+",
		"company": "Chmltech Ltd"
	}
]

const AIForGreenHydrogen = ({
	showRegisterForm,
	setShowRegisterForm,
	company
	}) => {
	const eventItem = EventData[0];
	return (
		<>
			<SEO
				title={ eventItem.title }
				description=""
			/>
			<Layout>
				<BreadcrumbOne 
					title={eventItem.title}
					rootUrl="/programs/work-integrated-learning"
					parentUrl="Industry Partner Work Integrated Learning"
					currentUrl={eventItem.title}
				/>
				<div className="edu-event-details-area edu-event-details edu-section-gap bg-color-white">
					<div className="container">
						<div className="row g-5">
							<div className="col-lg-12">
								<div className="thumbnail">
									<img src={`${process.env.PUBLIC_URL}/images/project-details/${ eventItem.image }`} alt="Event Thumb" />
								</div>
							</div>
						</div>
						<div className="row g-5">
							<div className="col-lg-7">
								<div className="content">
									<h3 className="title">{ eventItem.title }</h3>
									<p>
										<strong>What is the main goal for this project?</strong><br></br>
										This project explores how artificial intelligence can be applied to optimize the performance and decision-making processes within a green hydrogen microgrid system. The primary objective is to leverage data insights to improve how clean energy sources—such as solar power and hydrogen storage—are managed and balanced in real-time. The outcome of this project supports the broader mission of building smarter, more resilient, and sustainable energy systems for the future.
									</p>
									<p className="mb-0">
										<strong>What tasks will learners need to complete to achieve the project goal?</strong><br></br>
										Over the course of the project, learners will work on a variety of applied data and AI challenges, including:
									</p>
									<ul>
										<li>
											Analyzing operational data from renewable energy sources and storage systems.
										</li>
										<li>
											Identifying performance trends and inefficiencies within the microgrid environment.
										</li>
										<li>
											Designing predictive strategies to support energy planning and resource allocation.
										</li>
										<li>
											Developing a user-friendly visual dashboard to communicate key insights.
										</li>
										<li>
											Exploring ways AI can inform sustainable energy decisions and system improvements.
										</li>
									</ul>
									<p className="mb-0">
										Through these tasks, learners will gain valuable hands-on experience in applying AI tools to solve real-world problems in the clean energy sector.
									</p>
									<p className="mb-0">
										<strong>How will you support learners in completing the project?</strong><br></br>
										Learners will receive structured support from M2M Tech's technical team and the industry partner. This includes:
									</p>
									<ul>
										<li>
											Weekly mentorship check-ins and technical guidance from AI professionals.
										</li>
										<li>
											Feedback-driven milestones to ensure steady project progression.
										</li>
										<li>
											Access to curated tools, datasets, and collaboration platforms.
										</li>
										<li>
											Practical templates and learning resources to support implementation.
										</li>
										<li>
											Exposure to real-world challenges in renewable energy innovation.
										</li>
									</ul>
									<p className="mb-0">
										This project is ideal for learners who want to apply their AI and data skills to the growing field of clean energy and sustainability.
									</p>
								</div>
							</div>
							<div className="col-lg-5">
								<div className="eduvibe-sidebar">
									<div className="eduvibe-widget eduvibe-widget-details">
										<h5 className="title">ABOUT INDUSTRY PARTNER</h5>
										<div className="widget-content">
											<ul>
												{/* <li><span><i className="icon-Campus"></i> { eventItem.company }</span></li> */}
												<li><span><i className="icon-Campus"></i> <a href={eventItem.location}>{ eventItem.company }</a></span></li>
												<li><span><i className="icon-presentation"></i> { eventItem.category }</span></li>
												{/* <li><span><i className="icon-map-pin-line"></i> {company ? <a href={eventItem.location}>Website</a> : eventItem.location}</span></li> */}
												<li>
													Chmltech Ltd. is a cleantech company developing an AI-powered platform to optimize hydrogen energy storage for solar and wind systems. Their solution predicts energy demand, improves storage efficiency, and reduces maintenance costs - helping renewable energy producers and industrial facilities operate more sustainably. Based in Vancouver, Chmltech operates on a SaaS model and targets global markets driving the transition to net-zero energy.
												</li>
											</ul>
											{!company && <div className="read-more-btn mt--45">
												<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
											</div>}
										</div>
									</div>
								</div>
							</div>
							{!company && <div className="col-lg-12">
								<div className="read-more-btn text-center">
									<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</Layout>
			{showRegisterForm && <RegisterProgramForm setShowRegisterForm={setShowRegisterForm} />}
		</>
	)
}
export default AIForGreenHydrogen;